module.exports = __webpack_public_path__ + "static/icon-logo-dbaaf8549668c105fc1a794d9c4edf75.svg";